// import React from "react";
// import "./Home.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination } from "swiper/modules";
// import { Link } from "react-router-dom";
// import "swiper/css";
// import "swiper/css/pagination";
// import aries from "../../assets/icons/aries.png";
// import taurus from "../../assets/icons/taurus.png";
// import gemini from "../../assets/icons/gemini.png";
// import cancer from "../../assets/icons/cancer.png";
// import leo from "../../assets/icons/leo.png";
// import virgo from "../../assets/icons/virgo.png";
// import libra from "../../assets/icons/Libra.png";
// import scorpio from "../../assets/icons/Scorpio.png";
// import sagittarius from "../../assets/icons/Sagittarius.png";
// import capricorn from "../../assets/icons/Capricorn.png";
// import aquarius from "../../assets/icons/Aquarius.png";
// import pisces from "../../assets/icons/Pisces.png";

// const rashiData = [
//   { id: 1, name: "Aries", slug: "aries", image: aries },
//   { id: 2, name: "Taurus", slug: "taurus", image: taurus },
//   { id: 3, name: "Gemini", slug: "gemini", image: gemini },
//   { id: 4, name: "Cancer", slug: "cancer", image: cancer },
//   { id: 5, name: "Leo", slug: "leo", image: leo },
//   { id: 6, name: "Virgo", slug: "virgo", image: virgo },
//   { id: 7, name: "Libra", slug: "libra", image: libra },
//   { id: 8, name: "Scorpio", slug: "scorpio", image: scorpio },
//   { id: 9, name: "Sagittarius", slug: "sagittarius", image: sagittarius },
//   { id: 10, name: "Capricorn", slug: "capricorn", image: capricorn },
//   { id: 11, name: "Aquarius", slug: "aquarius", image: aquarius },
//   { id: 12, name: "Pisces", slug: "pisces", image: pisces },
// ];

// export default function RashiSection() {
//   return (
//     <section className="rashi-section">
//       <div className="rashi-container">
//         <div className="rashi-heading">
//           <span className="small-heading">DISCOVER YOUR ZODIAC MATCH</span>
//           <div className="heading-wrapper">
//             <h2>
//               Shop by <span>Rashi</span> 
//                <div className="about-heading-line">
//             <img
//               src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
//               alt="Heading decoration"
//             />
//           </div>
//             </h2>
//           </div>
//           <p className="headdd">Bracelets & gemstones matched to your Rashi.</p>
//         </div>
//         <Swiper
//           modules={[Autoplay, Pagination]}
//           slidesPerView={12}
//           spaceBetween={0}
//           loop
//           speed={800}
//           autoplay={{
//             delay: 2500,
//             disableOnInteraction: false,
//           }}
//           pagination={{ clickable: true }}
//           breakpoints={{
//             0: { slidesPerView: 3 },
//             480: { slidesPerView: 4 },
//             768: { slidesPerView: 6 },
//             1024: { slidesPerView: 8 },
//             1200: { slidesPerView: 12 },
//           }}
//         >
//           {rashiData.map((item) => (
//             <SwiperSlide key={item.id}>
//               {/* CategoryProducts page open hoga */}
//               <Link
//                 to={`/shop/shop-by-astrology/${item.slug}`}
//                 className="rashi-card"
//               >
//                 <div className="rashi-image">
//                   <img src={item.image} alt={item.name} />
//                 </div>

//                 <h4>{item.name}</h4>
//               </Link>
//             </SwiperSlide>
//           ))}
//         </Swiper>

//       </div>
//         {/* Premium CTA Button */}
//         <div className="rashi-button-wrapper">

//           <Link
//             to="/shop/shop-by-astrology"
//             className="rashi-explore-btn"
//           >
//             <span>Explore All Rashis</span>

//             <span className="rashi-btn-arrow">
//               →
//             </span>
//           </Link>

//         </div>
//     </section>
//   );
// }

// api integrated

import React, { useEffect, useState } from "react";
import "./Home.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/pagination";

// =====================================================
// RASHI IMAGES
// =====================================================

import aries from "../../assets/icons/aries.png";
import taurus from "../../assets/icons/taurus.png";
import gemini from "../../assets/icons/gemini.png";
import cancer from "../../assets/icons/cancer.png";
import leo from "../../assets/icons/leo.png";
import virgo from "../../assets/icons/virgo.png";
import libra from "../../assets/icons/Libra.png";
import scorpio from "../../assets/icons/Scorpio.png";
import sagittarius from "../../assets/icons/Sagittarius.png";
import capricorn from "../../assets/icons/Capricorn.png";
import aquarius from "../../assets/icons/Aquarius.png";
import pisces from "../../assets/icons/Pisces.png";

import { getCategories } from "../../api/getCategories";
const ASTROLOGY_CATEGORY_SLUG = "shop-by-astrology";
const rashiImages = {
  aries,
  taurus,
  gemini,
  cancer,
  leo,
  virgo,
  libra,
  scorpio,
  sagittarius,
  capricorn,
  aquarius,
  pisces,
};

const rashiOrder = [
  "aries",
  "taurus",
  "gemini",
  "cancer",
  "leo",
  "virgo",
  "libra",
  "scorpio",
  "sagittarius",
  "capricorn",
  "aquarius",
  "pisces",
];

export default function RashiSection() {

  const [rashiData, setRashiData] = useState([]);

  const [categoryId, setCategoryId] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  useEffect(() => {

    const fetchRashiSubcategories = async () => {

      try {

        setLoading(true);
        setError("");

        const result = await getCategories();

        if (!result?.success) {

          setRashiData([]);

          setError(
            result?.message ||
            "Unable to load Rashis"
          );

          return;
        }

        const astrology = (result?.data || []).find(
          (category) =>
            category?.slug?.toLowerCase() ===
            ASTROLOGY_CATEGORY_SLUG
        );

        if (!astrology) {

          setRashiData([]);

          setError("Unable to load Rashis");

          return;
        }

        setCategoryId(astrology.id);

        const subcategories =
          astrology.subcategories || [];

    
        const sortedRashis =
          [...subcategories].sort(
            (a, b) => {

              const indexA =
                rashiOrder.indexOf(
                  a?.slug?.toLowerCase()
                );

              const indexB =
                rashiOrder.indexOf(
                  b?.slug?.toLowerCase()
                );

              return (
                (indexA === -1 ? 999 : indexA) -
                (indexB === -1 ? 999 : indexB)
              );

            }
          );

      
        const formattedRashis =
          sortedRashis.map(
            (rashi) => {

              const slug =
                rashi?.slug?.toLowerCase();

              return {
                id: rashi.id,
                name: rashi.name,
                slug: slug,
                image:
                  rashiImages[slug] || null,
              };

            }
          );

        console.log(
          "Formatted Rashis:",
          formattedRashis
        );

        setRashiData(
          formattedRashis
        );

      } catch (err) {

        console.error(
          "Rashi API Error:",
          err
        );

        setRashiData([]);

        setError(
          "Unable to load Rashis"
        );

      } finally {

        setLoading(false);

      }

    };

    fetchRashiSubcategories();

  }, []);

  if (loading) {

    return (
      <section className="rashi-section">

        <div className="rashi-container">

          <div className="rashi-heading">

            <span className="small-heading">
              DISCOVER YOUR ZODIAC MATCH
            </span>

            <h2>
              Shop by <span>Rashi</span>
            </h2>

            <p className="headdd">
              Bracelets & gemstones matched to your Rashi.
            </p>

          </div>

          <div className="rashi-loading">
            Loading Rashis...
          </div>

        </div>

      </section>
    );

  }

  if (error) {

    return (
      <section className="rashi-section">

        <div className="rashi-container">

          <div className="rashi-heading">

            <span className="small-heading">
              DISCOVER YOUR ZODIAC MATCH
            </span>

            <h2>
              Shop by <span>Rashi</span>
            </h2>

            <p className="headdd">
              Bracelets & gemstones matched to your Rashi.
            </p>

          </div>

          <div className="rashi-loading">
            {error}
          </div>

        </div>

      </section>
    );

  }


  return (

    <section className="rashi-section">

      <div className="rashi-container">

        <div className="rashi-heading">

          <span className="small-heading">
            DISCOVER YOUR ZODIAC MATCH
          </span>

          <div className="heading-wrapper">

            <h2>

              Shop by <span>Rashi</span>

              <div className="about-heading-line">

                <img
                  src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                  alt="Heading decoration"
                />

              </div>

            </h2>

          </div>

          <p className="headdd">
            Bracelets & gemstones matched to your Rashi.
          </p>

        </div>


        {rashiData.length > 0 ? (

          <Swiper

            modules={[
              Autoplay,
              Pagination
            ]}

            slidesPerView={12}

            spaceBetween={0}

            loop={
              rashiData.length > 12
            }

            speed={800}

            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}

            pagination={{
              clickable: true,
            }}

            breakpoints={{

              0: {
                slidesPerView: 3,
              },

              480: {
                slidesPerView: 4,
              },

              768: {
                slidesPerView: 6,
              },

              1024: {
                slidesPerView: 8,
              },

              1200: {
                slidesPerView: 12,
              },

            }}

          >

            {rashiData.map(
              (item) => (

                <SwiperSlide
                  key={item.id}
                >

                  {/* =================================================
                      RASHI LINK
                  ================================================= */}

                  <Link
                    to={`/shop/shop-by-astrology/${item.slug}`}
                    state={{
                      subcategoryId:
                        item.id,
                      categoryId,
                      rashiName:
                        item.name,
                    }}
                    className="rashi-card"
                  >

                    <div className="rashi-image">

                      {item.image ? (

                        <img
                          src={item.image}
                          alt={item.name}
                        />

                      ) : (

                        <div className="rashi-image-placeholder">
                          {item.name}
                        </div>

                      )}

                    </div>

                    <h4>
                      {item.name}
                    </h4>

                  </Link>

                </SwiperSlide>

              )
            )}

          </Swiper>

        ) : (

          <div className="rashi-loading">
            No Rashis found
          </div>

        )}

      </div>

      {/* =================================================
          EXPLORE ALL
      ================================================= */}

      <div className="rashi-button-wrapper">

        <Link
          to="/shop/shop-by-astrology"
          className="rashi-explore-btn"
        >

          <span>
            Explore All Rashis
          </span>

          <span className="rashi-btn-arrow">
            →
          </span>

        </Link>

      </div>

    </section>

  );

}









